import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authService } from './services/authService';
// Components
import Home from './components/Home'
import ProductDetail from './components/ProductDetail'
import Header from './components/Header';
import SideBar from './components/SideBar';
import Login from './components/Login';
import Register from './components/Register';
import AdminPanel from './components/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Verificar si hay un usuario autenticado al cargar la app
    const user = authService.getCurrentUser();
    
    if (user) {
      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: { user }
      });
    }
  }, [dispatch]);

  return (
    <Router>
      <Header/>
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route path='/producto/:id' element={<ProductDetail />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route 
          path='/admin' 
          element={
            <ProtectedRoute adminOnly={true}>
              <AdminPanel />
            </ProtectedRoute>
          } 
        />
      </Routes>
      <SideBar/>
    </Router>
  );
}

export default App;
